class PaginationController extends window.StimulusController {
  static targets = [
    "productGrid",
    "loadMoreButton",
    "listSummary",
    "itemsViewed",
  ];

  pagination = {};

  connect() {
    if (this.hasLoadMoreButtonTarget) {
      this.pagination = this.#handlePaginationData();
    }
  }

  #handlePaginationData() {
    return {
      currentPage: parseInt(
        this.loadMoreButtonTarget.dataset.paginationCurrentPageValue,
      ),
      itemsPerPage: parseInt(
        this.loadMoreButtonTarget.dataset.paginationItemPerPageValue,
      ),
      totalPages: parseInt(
        this.loadMoreButtonTarget.dataset.paginationTotalPagesValue,
      ),
      totalItems: parseInt(
        this.loadMoreButtonTarget.dataset.paginationTotalItemsValue,
      ),
      url: window.location.pathname,
    };
  }

  get #shouldLoadMore() {
    return this.pagination.currentPage < this.pagination.totalPages;
  }

  async #parseNextPageItems() {
    const nextPage = parseInt(this.pagination.currentPage) + 1;

    const url = new URL(this.pagination.url, window.location.origin);
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set("page", nextPage);
    url.search = searchParams.toString();

    const response = await fetch(url);

    this.pagination.currentPage++;

    const html = await response.text();
    const parser = new DOMParser();
    const newDocument = parser.parseFromString(html, "text/html");
    const updatedProductGrid = newDocument.querySelector(
      "[data-pagination-target='productGrid']",
    );

    return updatedProductGrid.querySelectorAll("[data-card='cardItem']");
  }

  #renderItems(listItems) {
    listItems.forEach((item) => {
      this.productGridTarget.appendChild(item);
    });

    this.itemsViewedTarget.textContent = this.#itemsLength;

    if (!this.#shouldLoadMore) {
      this.loadMoreButtonTarget.remove();
    }

    document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
  }

  get #itemsLength() {
    return this.productGridTarget.querySelectorAll("[data-card='cardItem']")
      .length;
  }

  async loadMore(event) {
    event.preventDefault();

    if (!this.#shouldLoadMore) {
      return;
    }

    const listItems = await this.#parseNextPageItems();

    return this.#renderItems(listItems);
  }
}

Stimulus.register("pagination", PaginationController);
